import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      // display: 'flex',
      minHeight: '100vh',
      height: '100%',
    },
  },
  { name: 'BookingEngineLayout' },
);

const BookingEngineLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>{children}</div>
    </div>
  );
};

export default React.memo(BookingEngineLayout);
